import styled from 'styled-components';
import { FormTextField, TextField, FormControl } from 'components/ui';
import { Typography, Box } from '@mui/material';

export const STextField = styled(FormTextField)`
  background-color: ${({ theme }) => theme.palette.colors.white};
`;

export const SLabel = styled(Typography)`
  && {
    min-width: 130px;
    margin-right: 10px;
    white-space: nowrap;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: ${({ theme }) => theme.palette.colors.black100};
  }
`;

export const SFormControl = styled(FormControl)`
  gap: 5px;
`;
export const SBox = styled(Box)`
  width: 100%;

  & > .MuiFormControl-root {
    display: flex;
    width: 100%;

    & .MuiTypography-h5 {
      white-space: nowrap;
      margin-right: 10px;
      margin-bottom: 0;
      min-width: 100px;
    }
  }
`;

export const SInput = styled(TextField)`
  & .MuiInputBase-root {
    padding: 0 65px 0 10px;
  }
`;
